module.exports = __webpack_public_path__ + "static/media/ilustra-03.b56427a7.png";